const ITEMS = [
  "Monthly Bookkeeping",
  "Tax Preparation",
  "QuickBooks Support",
  "PA Sales & Use Tax",
  "Payroll Support",
  "Estimated Taxes",
  "Job Costing",
  "Catch-Up & Cleanup",
];

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap font-serif text-2xl italic text-pine/80">{item}</span>
          <span className="mx-8 h-1.5 w-1.5 rounded-full bg-gold" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-hairline bg-parchment py-5" data-testid="marquee">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
